import type { FeatureManifest } from '@/platform/navigation/featureManifest'
export const learnerRewardsManifest: FeatureManifest = { id: 'learner-rewards', path: 'learner-rewards/*', navPath: '/learner-rewards', label: 'Điểm thưởng', description: 'Quản lý điểm thưởng người dùng', load: () => import('./entry') }
